import React from 'react'

import { FaArrowRight, FaRegClock } from "react-icons/fa6";
import { BsClock } from "react-icons/bs";
const SecondSection = () => {
    return (
        <>

            <div className="w-11/12 flex flex-col-reverse justify-between gap-8 lg:gap-16 lg:flex-row lg:mb-0 mt-12 container">
                {/* <!-- Content Left --> */}
                <div data-aos="fade-right" data-aos-duration="1500" className="flex flex-col justify-between gap-4 lg:w-1/2">
                    <div className="flex flex-col justify-start gap-4">
                        <h1 className="text-blue-text text-4xl font-bold text-right">
                            PAPA GIOVANNI XXIII
                        </h1>
                        <p className="!leading-10 w-full mx-auto text-right text-blue-text font-normal text-2xl underline underline-offset-8 lg:mt-0 lg:mx-0">
                        Strada San Gillio 75 <br/>
                        10044 - Pianezza TO
                        </p>
                    </div>

                    <div className="">
                        <p className="text-3xl font-bold text-gray-text text-right">CONTATTI</p>

                        <div className="flex flex-col justify-end">

                            {/* <!-- Contact Info --> */}
                            <div className="flex flex-col justify-start mt-4 space-y-6 text-xl md:space-y-0 md:space-x-4">
                                <p className="text-right text-2xl font-medium text-pink-primary">Amministrazione</p>
                                <a href="mailto:accettazione@xxiii.it" className="text-2xl font-medium text-blue-text text-right no-underline">accettazione@xxiii.it</a>
                            </div>
                            {/* <!-- Contact Info --> */}
                            <div className="flex flex-col justify-start mt-4 space-y-6 text-xl md:space-y-0 md:space-x-4">
                                <p className="text-right text-2xl font-medium text-pink-primary">Direzione</p>
                                <a href="mailto:papa.giovanni@XXIII.it" className="text-2xl font-medium text-blue-text text-right no-underline">papa.giovanni@XXIII.it</a>
                            </div>
                            {/* <!-- Contact Info --> */}
                            <div className="flex flex-col justify-start mt-4 space-y-6 text-xl md:space-y-0 md:space-x-4">
                                <p className="text-right text-2xl font-medium text-pink-primary">Centro Congressi</p>
                                <a href="mailto:centro.congressi@XXIII.it" className="text-2xl font-medium text-blue-text text-right no-underline">centro.congressi@XXIII.it</a>
                            </div>
                            {/* <!-- Contact Info --> */}
                            {/* <div className="flex flex-col justify-start mt-4 space-y-6 text-xl md:space-y-0 md:space-x-4">
                                <p className="text-right text-2xl font-bold text-pink-primary">Servizio di Logopedia</p>
                                <a href="mailto:prenotazioni.logo@villairis.srl" className="text-2xl font-medium text-blue-primary text-right no-underline">prenotazioni.logo@villairis.srl</a>
                            </div> */}

                        </div>
                    </div>

                    <div className="flex items-center justify-end">
                        <a href="tel:011.9675075" className="flex items-center justify-between space-x-4 px-3 py-2 rounded-lg border-2 border-green-primary overflow-hidden cursor-pointer">
                            <img loading="lazy" src="/images/phone.png" alt="phone-icon" className="h-12" />
                            <p className="no-underline text-green-primary text-2xl font-black">011.9675075</p>
                        </a>
                    </div>
                </div>





                {/* <!-- Content Right --> */}
                <div className="relative flex flex-col justify-start items-center gap-4 lg:w-1/2">

                    <div className="flex flex-col sm:flex-row gap-4 w-full">
                        {/* Box 1 */}
                        <div data-aos="fade-up" data-aos-duration="1500" className="sm:w-1/2 bg-blue-primary  p-4">
                            {/* <img loading="lazy" src="/images/icons/clock.png" alt="clock-icon" className="h-12" /> */}
                            <BsClock className='h-12 w-12 text-white'/>
                            {/* <FaRegClock className="text-5xl text-blue-primary" /> */}
                            <p className="text-left text-xl font-bold text-white mt-4">ACCESSO </p>
                            <p className="text-left text-xl font-bold text-white mb-2">AI VISITATORI</p>
                            <p className="text-left text-xl text-white">TUTTI I GIORNI</p>
                            <div className="flex items-center space-x-2">
                                <p className="text-left text-xl text-white">12.45</p>
                                <FaArrowRight className="text-3xl text-white" />
                                <p className="text-left text-xl text-white">17.45</p>
                            </div>
                        </div>
                        {/* box 2 */}
                        <div data-aos="fade-up" data-aos-duration="1500" className="sm:w-1/2 bg-[#E7E7E7]  p-4 text-blue-text">
                            {/* <img loading="lazy" src="/images/icons/clock.png" alt="clock-icon" className="h-12" /> */}
                            <BsClock className='h-12 w-12 text-blue-text'/>
                            {/* <FaRegClock className="text-5xl text-blue-primary" /> */}
                            <p className="text-left text-xl font-bold mt-4">TELEFONO</p>
                            <p className="text-left text-xl font-bold mb-2">RECEPTION</p>
                            <p className="text-left text-xl">LUN / DOM</p>
                            <div className="flex items-center space-x-2">
                                <p className="text-left text-xl">08.00</p>
                                <FaArrowRight className="text-3xl" />
                                <p className="text-left text-xl">18.45</p>
                            </div>
                            <p className="text-left text-xl font-bold">ACCETTAZIONE</p>
                            <p className="text-left text-xl">LUN / VEN</p>
                            <div className="flex items-center space-x-2">
                                <p className="text-left text-xl">10.00</p>
                                <FaArrowRight className="text-3xl" />
                                <p className="text-left text-xl">13.00</p>
                            </div>
                        </div>
                    </div>

                    <div data-aos="fade-up" data-aos-duration="1500" className="flex space-x-4 w-full">
                        {/* Box 2 */}
                        <div className="w-full">
                            <div className="w-full h-[304px] overflow-hidden"> {/* Set desired height here */}
                            <img
                                src="/images/new/albero-fiorito-croped.jpg"
                                alt=""
                                className="w-full h-full object-cover object-bottom"
                            />
                            </div>
                        </div>
                    </div>

                </div>
            </div>








            <div  className="flex lg-h-[450px] flex-col lg:flex-row gap-8 lg:gap-16 w-full container mt-4 justify-between">
                <img
                    data-aos="fade-up" data-aos-duration="1500"
                    src="/images/new/vpg-gardern.jpg"
                    alt=""
                    className="w-full lg:w-1/2 overflow-hidden object-cover"
                />
                <img
                    data-aos="fade-up" data-aos-duration="1500"
                    src="/images/new/seats.jpeg"
                    alt=""
                    className="w-full lg:w-1/2 overflow-hidden object-cover"
                />    
            </div>

            <div className='container mt-12'>
                <p data-aos="fade-right" className='text-cls'>
                    Il servizio, svolto in palestra e a letto, offre diversi programmi terapeutici basati su tecniche fisiochinesiterapiche. 
                    L'obiettivo del <b>Centro Papa Giovanni XXIII</b> è ripristinare al massimo l'autonomia del paziente, favorendone il reinserimento 
                    sociale, familiare ed economico. Le terapie sono integrate con farmaci, ausili e moderne apparecchiature fisioterapiche.
                </p>
            </div>
        </>
    )
}

export default SecondSection